<template>
  <v-app>
    <b-row id="discounts" class="section-invert">
      <b-col md="12" lg="6" class="content my-auto">
        <h3>{{ $t('discounts.title') }}</h3>
        <p class="text-info" v-html="$t('discounts.subtitle')">
        </p>
        <div class="subtitle">
          <div class="subtitle-list subtitle-list mt-sm-5">
            <div>
              <p>
                <v-icon large v-text="'mdi-heart-pulse'"></v-icon>
                {{ $t('discounts.clinic-services') }}
                <v-icon
                  @click.stop="dialog1 = true"
                  v-text="'mdi-chevron-down'"
                ></v-icon>
              </p>
            </div>
            <div>
              <p>
                <v-icon large v-text="'mdi-tooth-outline'"></v-icon>
                {{ $t('price-cards.tooth-services')}}
                <v-icon
                  @click="dialog2 = !dialog2"
                  v-text="'mdi-chevron-down'"
                ></v-icon>
              </p>
            </div>
            <div>
              <p>
                <v-icon large v-text="'mdi-spa-outline'"></v-icon>
                {{ $t('price-cards.wellness-services')}}
                <v-icon
                  @click="dialog3 = !dialog3"
                  v-text="'mdi-chevron-down'"
                ></v-icon>
              </p>
            </div>
          </div>
        </div>
               <base-button style="color:white" class="btn-more-info-white" white outline href="/opensaludprime/descuentos"><span style="color:white">{{ $t('more-info-btn') }}</span></base-button>
      </b-col>
      <b-col md="12" lg="6">
        <div class="col-bg ml-lg-auto"></div>
      </b-col>

      <v-dialog v-model="dialog1" width="auto">
        <v-card>
          <v-card-title class="mt-2">
            {{ $t('discounts.clinic-services-description') }}
          </v-card-title>
          <v-card-text
            >
            <ul class="column_wrapper mt-4">
              <li v-for="(data, i) in medical_services" :key="i">
                {{ data }}
              </li>
            </ul>
          </v-card-text>
             <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog1 = false"
          >
            {{ $t('discounts.close')}}
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog2">
        <v-card>
          <v-card-title class="mt-2">
            {{ $t('discounts.teeth-services-description') }}
          </v-card-title>
          <v-card-text>
            <ul class="column_wrapper mt-4">
              <li v-for="(data, i) in teeth_services" :key="i">
                {{ data }}
              </li>
            </ul>
          </v-card-text>
           <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog2 = false"
          >
            {{ $t('discounts.close')}}
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog3">
        <v-card>
          <v-card-title class="mt-2">
            {{ $t('discounts.health-services-description') }}
          </v-card-title>
          <v-card-text
            >
            <ul class="column_wrapper">
              <li v-for="(data, i) in health_services" :key="i">
                {{ data }}
              </li>
            </ul>
          </v-card-text>
           <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog3 = false"
          >
            {{ $t('discounts.close')}}
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </b-row>
  </v-app>
</template>

<script>
/*eslint-disable */
export default {
  data() {
    const medical_services = this.$t('discounts.medical-services-list').split('<br>')
    const teeth_services = this.$t('discounts.teeth-services-list').split('<br>')
    const health_services = this.$t('discounts.health-services-list').split('<br>')
    return {
      dialog1: false,
      dialog2: false,
      dialog3: false,
      medical_services: medical_services,
      teeth_services: teeth_services,
      health_services: health_services
     /* medical_services:  [
        "Consultas de medicina primaria (medicina general y pediatría)",
        "Consulta de especialistas",
        "Médicos de diagnóstico",
        "Tratamientos médicos",
        "Hospitalización e intervenciones quirúrgicas",
        "Servicios médicos",
        "Alergología",
        "Anatomía patológica",
        "Angiología y cirugía vascular",
        "Aparato digestivo",
        "Cardiología",
        "Cirugía cardiovascular",
        "Cirugía general y Aparato digestivo",
        "Cirugía mamaria",
        "Cirugía maxilofacial",
        "Cirugía oncológica",
        "Cirugía pedríatica",
        "Cirugía plástica y reparadora",
        "Cirugía torácica",
        "Cirugía vascular",
        "Dermatología y venereología",
        "Endocrinología y nutrición",
        "Enfermería",
        "Hematología y hemoterapia",
        "Nefrología",
        "Neumología",
        "Neurocirugía",
        "Neurofisiología clínica",
        "Neurología",
        "Obstetricia y ginecología",
        "Oftalmología",
        "Oncología médica",
        "Oncología radioterápica",
        "Otorrinolaringología",
        "Rehabilitación",
        "Reumatología",
        "Traumatología y Ortopedia",
        "Urología",
        "Medicina general",
        "Pediatría",
        "Pediatría-Puericultura",
        "Clínicas y Hospitales",
        "Policlínicas",
        "Campimetrías",
        "Panorámica/Ortopantomografía",
        "Ecografías",
        "Mamografías",
        "T.A.C.",
        "Analísis clínicos",
        "Diagnóstico por la imagen",
        "Medicina nuclear",
      ],
      teeth_services: [
        "Primera vista y entrega de presupuesto",
        "Visita de revisón",
        "Educación bucodental",
        "Enseñanza de técnicas de cepillado",
        "Fluorizaciones",
        "Limpieza de boca anual. Tartrectomía",

        "Radiografías odontológicas (periapical, aleta, oclusal)",
        "Diagnóstico y sondaje",
        "Ajustes oclusales",
        "Retirar puntos",
        "Estudio implantológico",
        "Falso muñón de titanio",
        "Tornillo de cicatrización y de cementación",
      ],
      health_services: [
        "Acupuntura/Homeopatía/Naturopatía",
        "Avantsalud en forma",
        "Balnearios",
        "Centros de reconocimiento",
        "Cirugía refractiva oftalmológica láser",
        "Concepto Bobath",
        "Conservación de Células Madre-Cordón",
        "Dermatoscopia Digital",
        "Dietética",
        "Ecografías 3D y 4D",
        "Estética",
        "Fisioterapia y fisioterapia infantil",
        "Hidroterapia de colon",
        "Medicina Preventiva y Test Genéticos",
        "Ópticas y Audífonos",
        "Ortopedia",
        "Osteopatía",
        "Planes con niños",
        "Podología y Estudio de la pisada",
        "Prestaciones asistenciales a domicilio (atención postparto)",
        "Procedimientos mínimamente invasivos",
        "Psicología, pedagogía y logofoniatría",
        "Quiropráctica",
        "Rehabilitación cardiaca",
        "Terapia asistida con animales",
        "Tratamientos de deshabituación tabáquica",
        "Tratamientos de infertilidad",
        "Tratamiento ondas de choque (disfunción eréctil)",
        "Veterinarios",
        "Láser miopía, astigmatismo, hipermetropía",
        "Podología a domicilio",
        "Analítica a domicilio",
        "Fisioterapia a domicilio",
        "Prevención Cáncer cuello de útero/HPV",
        "Test genético cardiológico",
        "Cribado Cáncer de colon en sangre",
        "Test genético de la obesidad",
        "Test genético Cáncer pulmonar",
        "Chequeo oncológico",
        "Test genético Alzhéimer",
        "Test genético tromboembolismo",
        "Test genético Diabetes Tipo II",
        "Test genético Cáncer de mama",
        "Test prenatal no invasivo",
        "Preeclampsia",
        "Test de paternidad",
        "Huella genética",
        "Test de intolerancia alimentaria",
        "Test degeneración macular",
        "Sexo fetal en sangre materna",
        "Test melisa",
        "Test migraña",
        "Test intolerancia a la lactosa - fructosa",
        "Balón gástrico",
        "Cápsula endoscópica",
        "Láser verde próstata",
        "Láser en dermatología",
        "Láser en vascular/endoláser",
        "Cirugía percutánea del pie",
        "Vasectomía sin bisturí",
        "Blefaroplastia",
        "Abdominoplastia",
        "Rinoplastia",
        "Lifting",
        "Microinjertos capilares",
        "Mamoplastia de aumento",
        "Mamoplastia de reducción",
        "Cirugía íntima",
        "Liposucción",
      ], */
    };
  },
};
</script>

<style lang="scss">
.column_wrapper {
  column-count: 3;
}


@import "../../../static-appopensalud/css/public/layout.scss";
#discounts .col-bg {
  background-image: url(/static-appopensalud/img/bgs/discounts.jpg),
    linear-gradient(273deg, #ffffff96, transparent);
  background-position: center;
  background-blend-mode: overlay;
}
.medicos,
.bienestar {
  display: flex;
}
.v-dialog--active .v-card__title {
  color: #3238C4;
  justify-content: center;
  word-break:break-word;
}
.v-dialog__content .v-dialog--active .v-card__text ul li {
  margin-top: 5px;
}
@media (max-width: 1268px) {
  #discounts > div.content.my-auto.col-md-12.col-lg-6 > div > div > div > p {
    font-size: 1rem;
  }
}
@media (max-width: 960px) {
  .v-dialog__content .v-dialog--active {
    width: 85vw;
  }
  .medicos,
  .bienestar {
    display: block;
  }
  #wellness div.col-md-12:first-child{
    order: 2;
  }
  .column_wrapper{
    column-count: 1;
  }
  #discounts .subtitle{
    width: 100%;
  }
}
@media (max-width: 960px) and (orientation: landscape) {
  .column_wrapper{
    column-count: 3;
  }
}

@media (max-width: 1024px) {
  #wellness div.col-md-12:first-child{
    order: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/OpenSaludDiscounts.vue